import React from "react";
import { CallbackComponent, UserState } from "redux-oidc";
import UserManager from "./UserManager";
import { useHistory } from "react-router-dom";
import LoadingSpinner from "features/shared/components/loaders/LoadingSpinner";
import { useSelector } from "react-redux";
import IAppState from "infrastructure/store/IAppState";
import { useTranslation } from "react-i18next";

interface IProps {}

const CallbackPage: React.FC<IProps> = () => {
  // translations
  const tLabels = useTranslation("shared\\moduleNames").t;

  // router
  const routerHistory = useHistory();

  // store
  const userState = useSelector<IAppState, UserState>((store) => store.oidc);

  // helpers
  const errorHandler = (error: Error) => {
      if (userState.user) {
      routerHistory.push("/");
    }
  }

  // render
  return (
    <CallbackComponent
      userManager={UserManager}
      successCallback={() => routerHistory.push("/")}
      errorCallback={errorHandler}
    >
      <LoadingSpinner 
        useContainerBg={false}
        title={tLabels("callbackPage.title")}
      />
    </CallbackComponent>
  );
};

export default CallbackPage;
